<template>
  <div class="music">
    <div class="container mx-auto">
      <div class="text-left">
        <h3>制作物</h3>  
        <br>
        <a href="https://sites.google.com/view/biones/music?authuser=0">外部リンク</a>  
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "music",
  data() {
    return {
      msg: "thisis music page"
    };
  }
};
</script>